import { BaseJsonSchema, createSchemaByBasicTypes } from "../../../helpers";

export const IxBidSchema: BaseJsonSchema = {
  type: "object",
  properties: {
    bidder: {
      type: "string",
      enum: ["ix"],
    },
    params: {
      type: "object",
      properties: {
        siteId: createSchemaByBasicTypes("string", null, {
          additionalProperties: false,
        }),
      },
      required: ["siteId"],
    },
  },
  additionalProperties: false,
  required: ["bidder", "params"],
};
